export default "__VITE_ASSET__9b153508__"